import { useEffect } from 'react';
import { useRouter } from 'next/router';

const usePrefetch = (urls: string | string[]) => {
  const router = useRouter();

  useEffect(() => {
    const urlList = Array.isArray(urls) ? urls : [urls];
    urlList.forEach((url) => {
      router.prefetch(url);
    });
  }, [urls]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default usePrefetch;
